import axios from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { IAddress } from './interfaces';

const BASE_URL = `/${SERVICES.DOCUMENT}/shipping-address`;

export const requestCreateAddress = (data: IAddress) => {
  const payload = { ...data, zip: data.zip.code };
  return mutate(BASE_URL, async() => {
    try {
      await axios.post(BASE_URL, payload);
      Notistack.successMessage(' Address - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateAddress = (data: IAddress) => {
  const payload = { ...data, zip: data.zip.code };
  return mutate(BASE_URL, async() => {
    try {
      await axios.put(`${BASE_URL}/${payload.id}`, payload);
      Notistack.successMessage('Address - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteAddress = (data: IAddress) => {
  return mutate(BASE_URL, async() => {
    try {
      await axios.delete(`${BASE_URL}/${data.id}`);
      Notistack.successMessage('Address - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
